import {
  setStorage,
  getStorage,
} from './storage';

import * as piwik from './piwik';


/* eslint-disable */
export const event = (data) => {
  if (window) {
    if (window._paq) {
      window._paq.push([`trackEvent`, ...data]);
    } else {
      console.log([`trackEvent`, ...data]);
    }
  }
};

export const method = (type, data) => {
  if (window && window._paq) {
    window._paq.push([type, ...data]);
  } else {
    console.log([type, ...data]);
  }
}

const paramsToSave = {
  pk_source: `campaign_source`,
  pk_campaign: `campaign_name`,
  pk_medium: `campaign_medium`,
  pk_content: `campaign_content`,
  pk_kwd: `campaign_keyword`
};

export const savePiwikParams = (urlParams) => {
  Object.keys(paramsToSave).forEach((param) => {
    if (urlParams[param]) {
      setStorage({ key: param, value: urlParams[param], session: true });
    }
  });
};

export const getPiwikParams = () => {
  const savedParams = {};
  Object.keys(paramsToSave).forEach((param) => {
    const retreived = getStorage({ key: param, session: true });
    if (retreived) {
      savedParams[paramsToSave[param]] = retreived;
    }
  });

  return savedParams;
};


export const setABLeg = ({
  testName,
  variations,
  percentage = 100,
  trigger = () => true,
}, tries = 0) => {
  if (process.env.NODE_ENV === `production` && window && tries < 2) {
    if (typeof Piwik === `undefined`) {
      setTimeout(() => {
        return piwik.setABLeg({ testName, variations, percentage, trigger }, tries + 1);
      }, 3000);
    } else {
      const { Experiment } = Piwik.AbTesting;
      const myExper = new Experiment({
        name: testName,
        percentage,
        includedTargets: [{ attribute: `url`, inverted: `0`, type: `any`, value: `` }],
        excludedTargets: [],
        variations,
        trigger,
      });
      const selectedVariation = myExper.getActivatedVariationName();
      return selectedVariation;
    }
  } else {
    const selectedIndex = Math.floor(Math.random() * variations.length);
    const selectedVariation = variations[selectedIndex].name;
    return selectedVariation;
  }
};

export default { event, savePiwikParams, getPiwikParams, setABLeg, method };
